module.exports = __webpack_public_path__ + "img/cobelli.771644a1.jpg";